import type { VoidComponent } from "solid-js";
import type { IconName } from "../../../../../components/icon/Icon";
import { Icon } from "../../../../../components/icon/Icon";

type CancellationInfoItemProps = {
  icon: IconName;
  title: string;
  description: string;
};

const CancellationInfoItem: VoidComponent<CancellationInfoItemProps> = (props) => (
  <div class="flex gap-4">
    <div class="mt-0.5 flex size-9 shrink-0 items-center justify-center rounded-xs border border-status-subtle-informative bg-surface-status-subtle-informative icon-button-icon-tertiary-active">
      <Icon name={props.icon} size="xl" type="outline" />
    </div>
    <div class="flex flex-col">
      <h2 class="text-medium-semibold text-primary">{props.title}</h2>
      <p class="text-medium-regular text-secondary">{props.description}</p>
    </div>
  </div>
);

export default CancellationInfoItem;
